export function goToLogin(brandDomain: string) {
  if (
    import.meta.env.VITE_TARGET_ENV &&
    !['production'].includes(import.meta.env.VITE_TARGET_ENV)
  ) {
    return;
  }
  window.open(`${brandDomain}/login`, '_self');
}
